import React from 'react';
import { FaBriefcase } from 'react-icons/fa';

const experience = [
    {
        role: 'Software Engineering Intern',
        company: 'Stellantis',
        duration: 'Jan 2026 - Present',
        points: [
            'Built low-latency UDP pipelines (~30–70 µs) for real-time communication',
            'Implemented zero-copy data paths to reduce memory overhead',
            'Worked on QNX-based embedded systems (aarch64)',
            'Debugged across application, OS, and hardware layers',
        ],
    },
    {
        role: 'Software Engineer (Contract)',
        company: 'BMS College of Engineering',
        duration: 'Sept 2025 - Dec 2025',
        points: [
            'Migrated backend from MongoDB to MySQL, improving consistency and reducing cost',
            'Designed and deployed versioned REST APIs on Linux infrastructure',
            'Built end-to-end workflows integrating frontend and backend systems',
        ],
    },
];

const Experience = () => {
    return (
        <section id="experience" className="py-10 bg-gray-100 text-center shadow-lg dark:bg-gray-900">

            <div className="flex justify-center items-center mb-8">
                <h2 className="text-3xl font-extrabold text-gray-800 dark:text-gray-100 mt-8">
                    Experience
                </h2>
                <FaBriefcase className="dark:text-white text-gray-800 text-2xl ml-2" />
            </div>

            <div className="w-[95%] md:w-2/3 mx-auto bg-white dark:bg-gray-800 pb-6 shadow-lg rounded-2xl">

                <div className="relative">

                    {/* vertical line */}
                    <div className="absolute top-6 bottom-5 md:left-[.5] w-1 rounded-md bg-gray-500 h-[88%] progress"></div>

                    {/* top dot */}
                    <div className="absolute left-2 md:left-16 top-5 w-4 h-4 bg-teal-500 rounded-full animate-inside-out"></div>

                    {experience.map((exp, index) => (
                        <div key={index} className="relative pb-6 pt-4 text-left px-[15%]">

                            <h3 className="text-xl font-semibold text-teal-400">
                                {exp.role}
                            </h3>

                            <p className="text-gray-400">{exp.company}</p>
                            <p className="text-gray-500 text-sm mb-2">{exp.duration}</p>

                            <ul className="list-disc pl-5 text-gray-600 dark:text-gray-300 space-y-1">
                                {exp.points.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>

                        </div>
                    ))}
                </div>
            </div>

            <style jsx>{`
        @keyframes inside-out {
          0%, 100% { transform: scale(1.1); }
          50% { transform: scale(.8); }
        }
        .animate-inside-out {
          animation: inside-out 2s infinite ease-in-out;
        }
        @media (min-width: 950px) {
          .progress {
            margin-left: 4.4rem !important;
          }
        }
        @media (max-width: 950px) {
          .progress {
            margin-left: .9rem !important;
          }
        }
      `}</style>
        </section>
    );
};

export default Experience;